export enum RoughagePlusEvent {
  MonitorSegmentChanged = 'RV+ MonitorSegmentChanged',
  GraphSegmentChanged = 'RV+ GraphSegmentChanged',
  AdviceFromLeoOpened = 'RV+ AdviceFromLeoOpened',
  NotificationCTAClicked = 'RV+ NotificationCTAClicked',
}
